var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background white" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backTo },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Client's Carrier Network "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-16 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "mx-4 mt-5", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "page-header" }, [
                      _vm._v(_vm._s(_vm.pageHeader)),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n5", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "Enter a unique identifier for this client-carrier network and select the carriers from the list below."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v(
                        "Network identifier to differentiate between multiple networks"
                      ),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n2", attrs: { cols: "4" } },
                    [
                      _c("smart-text-field", {
                        attrs: {
                          placeholder: "Network Name",
                          required: true,
                          maxlength: 255,
                          clearable: true,
                        },
                        model: {
                          value: _vm.networkName,
                          callback: function ($$v) {
                            _vm.networkName = $$v
                          },
                          expression: "networkName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c("v-col", { staticClass: "pl-0", attrs: { cols: "12" } }, [
                    _c("label", { staticClass: "pro-section-lbl" }, [
                      _vm._v(
                        "Filter and select carriers that correspond to this network"
                      ),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "4" } },
                    [
                      _c("smart-text-field", {
                        staticClass: "employees-search",
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "css-class": { "mt-2": _vm.mdAndUp },
                          "background-color": "white",
                        },
                        on: {
                          clear: _vm.onClear,
                          input: function ($event) {
                            return _vm.applyFilters()
                          },
                          "enter-pressed": function ($event) {
                            return _vm.applyFilters()
                          },
                        },
                        model: {
                          value: _vm.term,
                          callback: function ($$v) {
                            _vm.term = $$v
                          },
                          expression: "term",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.selectedCarriers.length
                    ? _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "12" } },
                        [
                          _c("label", { staticClass: "pro-section-lbl mr-2" }, [
                            _vm._v("Selected carriers: "),
                          ]),
                          _vm._l(_vm.selectedCarriers, function (car) {
                            return _c(
                              "label",
                              {
                                key: car.name,
                                staticClass: "carrier-selected-lbl mr-2",
                              },
                              [_vm._v(_vm._s(car.name))]
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "clear-all-btn",
                              attrs: { text: "", small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.clearSelectedCarriers()
                                },
                              },
                            },
                            [_vm._v("Clear All")]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    { staticClass: "pl-0 mt-n2", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "br-8", attrs: { elevation: "1" } },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("v-data-table", {
                                key: _vm.tableKey,
                                attrs: {
                                  id: "users-grid",
                                  headers: _vm.contractsHeaders,
                                  items: _vm.page,
                                  "hide-default-footer": true,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("v-checkbox", {
                                          ref: _vm.getRefName(item.id),
                                          staticClass: "mt-0 smart-checkbox",
                                          attrs: {
                                            ripple: false,
                                            "hide-details": true,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onCarrierSelect(item)
                                            },
                                          },
                                          model: {
                                            value: item.selected,
                                            callback: function ($$v) {
                                              _vm.$set(item, "selected", $$v)
                                            },
                                            expression: "item.selected",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.contactName",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getContactName(item)) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.contactEmail",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getContactEmail(item)) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.contactPhone",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getContactPhone(item)) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.eq",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return _vm._l(
                                        item.equipmentTypes,
                                        function (eq) {
                                          return _c(
                                            "label",
                                            {
                                              key: eq.equipmentId,
                                              staticClass:
                                                "equipment-type-lbl mr-2",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(eq.equipment.description)
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-6" },
                        [
                          _vm.pagingLength > 1
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "pl-0",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("v-pagination", {
                                    staticClass: "pl-3",
                                    attrs: {
                                      length: _vm.pagingLength,
                                      "total-visible": "10",
                                    },
                                    on: { input: _vm.pageChange },
                                    model: {
                                      value: _vm.currentPage,
                                      callback: function ($$v) {
                                        _vm.currentPage = $$v
                                      },
                                      expression: "currentPage",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("smart-btn", {
                                attrs: {
                                  label: "Cancel",
                                  bg: "white",
                                  border: "navy-blue",
                                  font: "navy-blue",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.confirmCancel = true
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c("smart-btn", {
                                class: { "w-100-pct": _vm.smAndDown },
                                attrs: {
                                  label: _vm.saveNetworkBtnLabel,
                                  type: "primary",
                                },
                                on: { click: _vm.showConfirm },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(_vm._s(_vm.loadingMessage)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayPopup,
            callback: function ($$v) {
              _vm.displayPopup = $$v
            },
            expression: "displayPopup",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "py-10 px-10 ta-c",
                      attrs: { row: "", wrap: "" },
                    },
                    [
                      !_vm.formValid
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Errors found"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid
                        ? _c("v-flex", [
                            _c("label", { staticClass: "are-you-sure-lbl" }, [
                              _vm._v("Confirm the change"),
                            ]),
                          ])
                        : _vm._e(),
                      _c("v-col", { attrs: { cols: "12" } }),
                      _vm.emptyFields
                        ? _c("v-flex", { staticClass: "ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(" Please correct the "),
                              _c("b", [_vm._v("following errors")]),
                              _vm._v(": " + _vm._s(_vm.emptyFields)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.formValid
                        ? _c("v-flex", { staticClass: "ta-c" }, [
                            _c("label", { staticClass: "text-lbl" }, [
                              _vm._v(
                                " Please confirm that you wish to save this carrier network. Once saved, clients will be able to view and select this network when creating spot market bids."
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "v-row",
                        { staticClass: "ta-c w-100-pct" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "mt-8", attrs: { cols: "12" } },
                            [
                              _vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "mr-4",
                                    attrs: { type: "dismiss", label: "Cancel" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayPopup = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "m0auto",
                                    attrs: {
                                      type: "primary",
                                      label: "OK",
                                      loading: _vm.saving,
                                    },
                                    on: { click: _vm.submitForm },
                                  })
                                : _vm._e(),
                              !_vm.formValid
                                ? _c("smart-btn", {
                                    staticClass: "m0auto",
                                    attrs: { type: "primary", label: "OK" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayPopup = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.confirmCancel,
            callback: function ($$v) {
              _vm.confirmCancel = $$v
            },
            expression: "confirmCancel",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "py-10 px-10 ta-c",
                      attrs: { row: "", wrap: "" },
                    },
                    [
                      _c("v-flex", [
                        _c("label", { staticClass: "are-you-sure-lbl" }, [
                          _vm._v("Save Changes Before Leaving?"),
                        ]),
                      ]),
                      _c("v-flex", { staticClass: "mt-6 ta-c" }, [
                        _c("label", { staticClass: "text-lbl" }, [
                          _vm._v(
                            " Your changes have not been saved. Leaving this page will result in losing them. Are you sure you want to leave?"
                          ),
                        ]),
                      ]),
                      _c(
                        "v-row",
                        { staticClass: "ta-c w-100-pct" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "mt-8", attrs: { cols: "12" } },
                            [
                              _c("smart-btn", {
                                staticClass: "mr-4",
                                attrs: { type: "dismiss", label: "Stay" },
                                on: {
                                  click: function ($event) {
                                    _vm.confirmCancel = false
                                  },
                                },
                              }),
                              _c("smart-btn", {
                                staticClass: "m0auto",
                                attrs: {
                                  type: "primary",
                                  label: "Go to Client's Carrier Network",
                                },
                                on: { click: _vm.backTo },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "smart-snackbar",
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "#007BFF", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.snackbar = false
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_vm._v(" Close ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _c("img", {
                    staticClass: "success-icon",
                    attrs: { src: _vm.ic_green_success_checkmark },
                  }),
                  _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }